// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'lib-flexible/flexible.js'
//import Echarts from 'echarts';
import axios from 'axios'
import Vueaxios from 'vue-axios'
import { Alert, Confirm, Toast } from 'wc-messagebox'
import MobileSelect from 'mobile-select'
import DataLoading from './components/loading/DataLoading'
import CSFCLoading from './components/loading/CSFCLoading'
import _global from './components/global'
import 'wc-messagebox/style.css'
//import layer from 'vue-layer'
//import VueCupUi from 'vue-cup-ui';
//import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// 适配 搜狐  获取ip 地址失败的情况
if (typeof returnCitySN == 'undefined') {
 window.returnCitySN = {};
}
//公司内网和测试环境开启调试
if((returnCitySN.cip=='222.135.186.170'||window.location.href.indexOf('-test')>=0)&&navigator.platform!=='Win32'){
  let vConsole = new VConsole();
}


//Vue.use(ElementUI)
Vue.use(Alert, {})
Vue.use(Confirm, {})
Vue.use(Toast, {})
Vue.use(Vueaxios, axios)
//Vue.use(VueCupUi)
//Vue.use(VueAwesomeSwiper)

// swiper
//import 'swiper/dist/css/swiper.min.css';

// 通用样式
import './assets/style/global.css';
// filters
import './assets/js/filters.js';
// mixin  全局混入方法
import mixin from "./assets/js/mixin.js";
Vue.mixin(mixin);
//工具
import Util from './assets/js/util.js';
Vue.prototype.Util=Util;

Vue.config.productionTip = false
Vue.prototype.Global = _global
//Vue.prototype.Echarts = echarts//cdn 修改 原来为 Echarts
Vue.prototype.MobileSelect = MobileSelect
var _inArrayFlag = false;
Vue.prototype.in_array = function(search, array){
  for(var i in array){
    if(_inArrayFlag){break;}
    if (Object.prototype.toString.call(array[i]).indexOf('Object') > -1 || Object.prototype.toString.call(array[i]).indexOf('Array') > -1) {
       _inArrayFlag = Vue.prototype.in_array(search, array[i]);
    } else {if(array[i] == search){_inArrayFlag = true;break;}}}
  if(_inArrayFlag){_inArrayFlag = false;return true;
  }else{return null;}
}

Vue.component('DataLoading', DataLoading);
Vue.component('CSFCLoading', CSFCLoading);

axios.interceptors.request.use(function (config) {
  store.dispatch('updateApiLoadingList', 1);//加载队列加一
  if (!config.noloading && store.state.apiLoadingList.length==1) {
    // 如果设置 CSFCLoading 参数， 则使用城市房产加载图标，否则显示默认加载图标
    let loader = config.CSFCLoading ? 'CSFCloader' : 'loader';
    if(config.nolazyloading){//无需延迟加载
      store.dispatch(`show${loader}`);
    }else{
      setTimeout(function(){//延迟出加载等待框（请求很短的接口没必要每次都出）
        if(store.state.apiLoadingList.length>0)
          store.dispatch(`show${loader}`);
      },1500)
    }
  }
  if(!config.params) config.params = {};
  //如果请求中没有http域名，则补全请求链接
  if (config.url.indexOf('http') == -1) {
    if (config.url.indexOf('json') >=0) {//如果请求中有json则调用测试地址
      config.url = process.env.STATIC_HOST + config.url;
    } else {//如果没有json
      config.url = location.protocol+'//'+location.hostname+(location.port=='80'?'':(':'+location.port)) + config.url;
    }
  }
  //设置超时
  if(config.timeout==0){
    config.timeout=process.env.NODE_ENV == 'development'?1000*20:1000*30;
  }
  if(config.url.indexOf('api/avm/assess')>=0){
    config.timeout=0
  }
  //追加渠道码
  if (config.url.indexOf('channel=') == -1) config.url = config.url+(config.url.indexOf('?')>=0?'&':'?')+'channel='+store.getters.getChannel;

  //window.KeepAliveState=[{MyHouse:1}];
  //根据接口请求设置keepaliveState状态是否需要清理页面缓存，接口行为通知 clearKeepAlive状态为1；
  //重新评估后需要清理keepalive的页面
  //Util.setState({page:"tradeList"});
  if(config.url.includes('api/suit/update')){
    Util.setState({page:"tradeList"});
  }
  //取消axios
  window._axiosPromiseArr=[]
  config.cancelToken = new axios.CancelToken(function(cancel){
    window._axiosPromiseArr.push(cancel)
  })

  return config;
}, function (error) {
  store.dispatch('updateApiLoadingList', -1);//加载队列减一
  return Promise.reject(error);
})
axios.interceptors.response.use(
  response => {
      store.dispatch('updateApiLoadingList', -1);//加载队列减一
      if (store.state.apiLoadingList.length<=0){//最后一个负责关闭loading（即使没有加载loading）
        let loader = response.config.CSFCLoading ? 'CSFCloader' : 'loader';
        store.dispatch(`hide${loader}`);
      }

    if(response.data.status==401){
      console.log('main检测已过期' + store.getters.getRealChannel())
      //登录后置的渠道
      if(0&&store.getters.getRealChannel()=='cityhouse.mobile.gjh'){
        store.dispatch('updateUserToken', '').then(function(){
          if(response.config.url.indexOf('needlogin')>=0&&confirm('登录已过期，是否再次登录？')){
            let nowUrl=location.href+(location.href.includes('?')?'&':'?')+'loginfmain=1';
            router.push({name: 'Oauth',query: {state: store.getters.getChannel,to:encodeURIComponent(nowUrl)}});
          }
        });
      } else if(store.getters.getRealChannel()=='cityhouse.mobile.applet') {
        console.log("401");
      } else{
        if(confirm('登录已过期，是否再次登录？')){
          store.dispatch('updateUserToken', '').then(function(){
            router.push({name: 'Oauth',query: {state: store.getters.getChannel,to:encodeURIComponent(location.href)}});
          });
        }
      }
    }else if (response.data.status==400){
      //Vue.prototype.$alert(response.data.errmsg);
    }else if (response.data.status==500){
      Vue.prototype.$alert(response.data.errmsg);
    }
    return response;
  },
  error => {
    store.dispatch('updateApiLoadingList', -1);//加载队列减一
    if (store.state.apiLoadingList.length<=0){//最后一个负责关闭loading（即使没有加载loading）
      let loader = error.config.CSFCLoading ? 'CSFCloader' : 'loader';
      store.dispatch(`hide${loader}`);
    }
    // 手动取消axios请求，不需要弹框提示
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    if(0&&error.indexOf('timeout')>=0){
      var emsg='请求超时！请稍后再试';
    }else{
      var emsg='系统异常：'+error;
    }
    Vue.prototype.$toast(emsg);
    return Promise.reject(error)
  }
);

/* eslint-disable no-new */
var fcgjwechatinstance=new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});
Vue.instance=fcgjwechatinstance;



// WEBPACK FOOTER //
// ./src/main.js